// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var MM_wrk_ctx = require("./MM_wrk_ctx.bs.js");
var MM_proof_tree = require("../mm-utils/MM_proof_tree.bs.js");
var Belt_MutableMap = require("rescript/lib/js/belt_MutableMap.js");
var Belt_MutableSet = require("rescript/lib/js/belt_MutableSet.js");
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");

var procName = "MM_wrk_unify";

function unify(preCtxVer, preCtx, parenStr, varsText, disjText, hyps, stmts, onProgress) {
  return Expln_utils_promise.promise(function (resolve) {
              MM_wrk_ctx.beginWorkerInteractionUsingCtx(preCtxVer, preCtx, parenStr, varsText, disjText, hyps, procName, /* Unify */{
                    stmts: stmts
                  }, (function (resp, sendToWorker, endWorkerInteraction) {
                      if (resp.TAG === /* OnProgress */0) {
                        return Curry._1(onProgress, resp._0);
                      }
                      Curry._1(endWorkerInteraction, undefined);
                      Curry._1(resolve, resp._0);
                    }), false, undefined);
            });
}

function processOnWorkerSide(req, sendToClient) {
  var proofTree = MM_proof_tree.proofTreeProve(MM_wrk_ctx.getWrkCtxExn(undefined), MM_wrk_ctx.getWrkFrmsExn(undefined), req.stmts, MM_wrk_ctx.getWrkParenCntExn(undefined), false, undefined, (function (pct) {
          Curry._1(sendToClient, {
                TAG: /* OnProgress */0,
                _0: pct
              });
        }), undefined);
  Curry._1(sendToClient, {
        TAG: /* Result */1,
        _0: {
          newVars: Belt_MutableSet.toArray(proofTree.newVars),
          disj: proofTree.disj,
          nodes: Belt_MutableMap.valuesToArray(proofTree.rootNodes)
        }
      });
}

exports.procName = procName;
exports.unify = unify;
exports.processOnWorkerSide = processOnWorkerSide;
/* MM_wrk_ctx Not a pure module */
